const Video = (props) => {
    return (
      <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M15.2408 4.56175C15.4008 4.6495 15.5 4.8175 15.5 5V10.5C15.5 10.6825 15.4008 10.8505 15.2408 10.9382C15.1655 10.9795 15.0828 11 15 11C14.9065 11 14.8132 10.974 14.7315 10.922L12.75 9.661V10.5C12.75 11.465 11.9648 12.25 11 12.25H3.5C2.53525 12.25 1.75 11.465 1.75 10.5V5C1.75 4.035 2.53525 3.25 3.5 3.25H11C11.9648 3.25 12.75 4.035 12.75 5V5.839L14.7315 4.578C14.8857 4.48 15.0805 4.474 15.2408 4.56175ZM11.75 10.5V5C11.75 4.5865 11.4135 4.25 11 4.25H3.5C3.0865 4.25 2.75 4.5865 2.75 5V10.5C2.75 10.9135 3.0865 11.25 3.5 11.25H11C11.4135 11.25 11.75 10.9135 11.75 10.5ZM14.5 9.589V5.911L12.75 7.02475V8.4755L14.5 9.589Z" fill="white"/>
      </svg>
  
    );
  };
  
  export default Video;